(function () {
  'use strict';
  const records = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const connection = navigator.connection;
  const saveData = Boolean(connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || ''));
  const canAutoplay = !reduced && !saveData;
  function hydrate(video) {
    const record = records.get(video);
    if (!record || record.hydrated) return;
    let changed = false;
    video.querySelectorAll('source[data-pp-video-src]').forEach(source => {
      source.src = source.dataset.ppVideoSrc;
      source.removeAttribute('data-pp-video-src');
      changed = true;
    });
    record.hydrated = true;
    if (changed) { video.preload = 'metadata'; video.load(); }
  }
  function syncButton(video) {
    const section = video.closest('section');
    const toggle = section?.querySelector('[data-pp-how-toggle]');
    if (toggle) {
      toggle.classList.toggle('is-paused', video.paused);
      toggle.setAttribute('aria-pressed', String(video.paused));
      toggle.setAttribute('aria-label', video.paused ? 'Play product animation' : 'Pause product animation');
    }
  }
  function reconcile() {
    let selected = null, best = 0;
    if (!document.hidden) records.forEach((record, video) => {
      if (record.ratio >= 0.35 && !record.manualPaused && ((canAutoplay && (video.hasAttribute('data-pp-video-autoplay') || video.classList.contains('pp-hero__video'))) || record.userPlay) && record.ratio + (record.userPlay ? 2 : 0) > best) {
        selected = video; best = record.ratio + (record.userPlay ? 2 : 0);
      }
    });
    records.forEach((record, video) => {
      if (video !== selected) { if (!video.paused) video.pause(); return; }
      hydrate(video);
      if (video.paused) video.play()?.catch(() => {});
    });
  }
  const warm = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && canAutoplay) { hydrate(entry.target); warm.unobserve(entry.target); }
    });
  }, { rootMargin: '600px 0px', threshold: 0 }) : null;
  const visible = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { const record = records.get(entry.target); if (record) record.ratio = entry.isIntersecting ? entry.intersectionRatio : 0; });
    reconcile();
  }, { threshold: [0, 0.35, 0.6, 1] }) : null;
  function mount(root) {
    root.querySelectorAll('video.pp-hero__video, video.pp-how__video, video.pp-proof__video').forEach(video => {
      if (records.has(video)) return;
      records.set(video, { hydrated: !video.querySelector('source[data-pp-video-src]'), ratio: 0, manualPaused: false, userPlay: false });
      video.addEventListener('play', () => syncButton(video));
      video.addEventListener('pause', () => syncButton(video));
      syncButton(video);
      if (warm && visible) { warm.observe(video); visible.observe(video); }
    });
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-pp-play], [data-pp-how-toggle], [data-pp-sound-toggle], [data-pp-how-sound-toggle], [data-pp-sound]');
    if (!control) return;
    const video = (control.closest('[data-pp-ugc-card]') || control.closest('section'))?.querySelector('video');
    const record = records.get(video);
    if (!record) return;
    const sound = control.hasAttribute('data-pp-sound-toggle') || control.hasAttribute('data-pp-how-sound-toggle') || control.hasAttribute('data-pp-sound');
    record.manualPaused = !sound && !video.paused;
    record.userPlay = !record.manualPaused;
    hydrate(video);
    queueMicrotask(reconcile);
  }, true);
  document.addEventListener('visibilitychange', reconcile);
  window.addEventListener('pagehide', () => records.forEach((record, video) => video.pause()));
  window.addEventListener('pageshow', reconcile);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => records.forEach((record, video) => {
    if (event.target.contains(video)) { video.pause(); warm?.unobserve(video); visible?.unobserve(video); records.delete(video); }
  }));
  const prefetched = new Set();
  function prefetch(event) {
    if (saveData || prefetched.size >= 2) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.search || url.pathname === location.pathname || !/^\/(?:products|collections|pages|blogs)\//.test(url.pathname)) return;
    url.hash = '';
    if (prefetched.has(url.href)) return;
    prefetched.add(url.href);
    const hint = document.createElement('link'); hint.rel = 'prefetch'; hint.as = 'document'; hint.href = url.href;
    document.head.append(hint);
  }
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);
  document.addEventListener('pointerdown', prefetch, { passive: true });
  mount(document);
})();
